import moment from 'moment-timezone'
import _ from 'lodash'
import ExcelJS from 'exceljs'

import { AG_GridCustomizedTableHeaders_Key, Notisphere_RecallsFeed_Headers, Provider_RecallsFeed_Drug_Extra_Headers } from '../../../misc/tableHeaders'
import recallsFeedServices from '../../../services/notisphere/recalls-feed'
import recallReviewServices from '../../../services/notisphere/recallReview'
import DetailsTab from '../recall-review/RecallReviewModal/components/DetailsTab.vue'
import FileStatusModal from '../fda/devices/file-status-modal'
import ImportDeviceModal from '../fda/devices/import-device-modal'
export default {
    components: {
        DetailsTab,
        FileStatusModal,
        ImportDeviceModal
    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 20, sort: null, colId: null },
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                singleClickEdit: true,
                serverSideSortAllLevels: true,
                suppressServerSideInfiniteScroll: true
            },
            gridApi: null,
            columnApi: null,
            delay: 700,
            recall_type: 'device',
            clicks: 0,
            timer: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            customDefaultColDef: {
                flex: 1,
                minWidth: 100,
                enableValue: true,
                enableRowGroup: false,
                enablePivot: true,
                sortable: true,
                resizable: true,
                filter: true,
                editable: false,
                wrapText: false,
                autoHeight: false,
                wrapHeaderText: false,
                autoHeaderHeight: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    buttons: ['apply', 'reset'],
                    closeOnApply: true,
                },
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
            },
            recallData: null,
            globalSearchText: '',
            lastUpdated: '',
            modalTitle: 'Recall Details',
            selectedRecallGroup: 'Medical Devices',
            recallGroupOptions: ['Medical Devices', 'Drugs'],
            modalUdiFieldHeader: [
                {
                    key: 'udi',
                    label: 'UDI'
                },
                {
                    key: 'normalized_udi',
                    label: 'Normalized UDI',
                },
                {
                    key: 'is_valid',
                    label: 'Is Valid'
                },
                {
                    key: 'all_lots',
                    label: 'All Lots'
                },
                {
                    key: 'lots',
                    label: 'Lots'
                },
                {
                    key: 'is_kit',
                    label: 'Is Kit'
                },
                {
                    key: 'is_implantable',
                    label: 'Is Implantable'
                }
            ],
            activeEditingCell: null,
            deviceModalKey: 0,
            fileStatusModalKey: 0
        }
    },
    beforeMount() {
        this.columnDefs = this.getColumnDefs(this.selectedRecallGroup)
    },
    created() {
        this.rowModelType = 'serverSide'
        //this.fetchMetaData()
    },
    methods: {
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.RecallsFeed_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        setFilterModel(params) {
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            const filterModel = tableState?.Notisphere_Login?.RecallsFeed_Filters || {}
            params.api.setFilterModel(filterModel)
        },
        applyState(params) {
            const userId = this.$store.state.user.id
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId === userId)[0]
            let columnState = tableState?.Notisphere_Login?.RecallsFeed_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            const filterModel = event.api.getFilterModel()
            this.table_Connection_Data.Notisphere_Login.RecallsFeed_Filters = filterModel
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onColumnVisible(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        getColumnDefs(recallGroup) {
            let columnDefs = _.cloneDeep(Notisphere_RecallsFeed_Headers)
            // If the recall group is 'Drugs', add Drug-specific columns before the 'actions' column
            if (recallGroup === 'Drugs') {
                // Find the actions column index
                const actionsIndex = columnDefs.findIndex(col => col.field === 'source')
                if (actionsIndex !== -1) {
                    // Insert Drug extra headers before the source column
                    const drugExtraColumnsCopy = _.cloneDeep(Provider_RecallsFeed_Drug_Extra_Headers)
                    columnDefs.splice(actionsIndex, 0, ...drugExtraColumnsCopy)
                }
            }
            return columnDefs
        },
        recallGroupChange(recallGroup) {
            this.selectedRecallGroup = recallGroup
            // Update column definitions for the new recall group
            this.columnDefs = this.getColumnDefs(recallGroup)
            if (this.gridApi) {
                // Then fetch data with the new recall group
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        fetchData(params) {
            let that = this
            this.applyState(params)
            this.setFilterModel(params)
            that.gridApi = params.api
            that.columnApi = params.columnApi
            localStorage.setItem(
                'agGridColumState',
                JSON.stringify(params.columnApi.getColumnState())
            )
            localStorage.setItem(
                'agGridFilterModel',
                JSON.stringify(params.api.getFilterModel())
            )
            const filterModel = that.gridApi.getFilterModel()
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            const datasource = {
                getRows(params) {
                    // Get visible columns and extract their field names
                    const visibleColumns = that.columnApi.getAllDisplayedColumns()
                    const visibleFields = ['source_id', ...visibleColumns
                        .map(col => col.getColDef().field)
                        .filter(field => field)]
                        .join(',')

                    recallsFeedServices.getAllRecallsFeed({
                        search: that.globalSearchText,
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel,
                        fields: visibleFields,
                        recallGroup: that.selectedRecallGroup
                    }).then((resp) => {
                        if(resp && resp.data) {
                            that.items = resp.data.d.data
                            that.total = resp.data.d.totalCount
                            if(that.total == 0){
                                that.gridApi.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi.hideOverlay()
                            }
                            params.successCallback(resp.data.d.data)
                        } else {
                            params.failCallback()
                            that.total = 0
                        }
                    })
                }
            }
            params.api.setServerSideDatasource(datasource)
        },
        fetchMetaData() {
            recallsFeedServices.getRecallsFeedMetaData().then(resp => {
                if(resp && resp.data) {
                    this.lastUpdated = `${moment(resp.data.data.completed_date).local().format('MM/DD/YY')}`
                } else {
                    this.lastUpdated = ''
                }
            })
        },
        onCellClicked({ colDef, data }) {
            if (colDef.field === 'recall_type') {
                return
            }
            if (colDef && colDef.field === 'recall_link') {
                data.event.preventDefault()
            }
            if( data.source === 'OpenFDA') {
                recallsFeedServices.getRecallFeedById(data.id).then(resp => {
                    if(resp && resp.data) {
                        this.recallData = { ...resp.data.d.data }
                    }
                    if (this.recallData != null) {
                        this.$nextTick(()=>{
                            this.$refs.recallFdaModal.show()
                        })
                    }})
            } else {
                recallReviewServices.getRecallReviewById(data.source_id).then(resp => {
                    if(resp && resp.data) {
                        this.recallData = { ...resp.data.d.data }
                    }
                    if (this.recallData != null) {
                        this.$nextTick(()=>{
                            this.$refs.recallNotisphereModal.show()
                        })
                    }
                })
            }
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    try {
                        // Get currently displayed rows from the grid (uses items array which contains current page data)
                        const data = that.items || []
                        if (data.length > 0) {
                            // Get visible columns from grid in display order, excluding action columns
                            const columnState = that.columnApi.getColumnState()
                            const visibleColumns = columnState.filter(col => {
                                if (col.hide) return false
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                // Exclude action columns
                                if (col.colId === 'actions') return false
                                if (colDef.headerName === 'Actions') return false
                                return true
                            })
                            // Prepare headers and data for export
                            const headers = visibleColumns.map(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                return colDef.headerName || col.colId
                            })
                            // Create workbook using ExcelJS
                            const workbook = new ExcelJS.Workbook()
                            const worksheet = workbook.addWorksheet('Recalls Feed')
                            // Prepare data first to calculate column widths
                            const exportData = []
                            data.forEach(row => {
                                const rowData = {}
                                visibleColumns.forEach(col => {
                                    const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                    const headerName = colDef.headerName || col.colId
                                    // Handle nested field names (e.g., openfda.device_class)
                                    let value
                                    if (col.colId.includes('.')) {
                                        const keys = col.colId.split('.')
                                        value = row
                                        for (const key of keys) {
                                            value = value?.[key]
                                            if (value === undefined || value === null) break
                                        }
                                    } else {
                                        value = row[col.colId]
                                    }
                                    // Handle urgent field - show blank if 'Unknown'
                                    if (col.colId === 'urgent' && value === 'Unknown') {
                                        value = ''
                                    }
                                    // Format dates using the same format as displayed in grid (MM/DD/YYYY)
                                    else if (value && colDef.cellRenderer && typeof colDef.cellRenderer === 'function') {
                                        // Check if it's a date field by checking if cellRenderer uses moment
                                        const rendererString = colDef.cellRenderer.toString()
                                        if (rendererString.includes('moment') && rendererString.includes('format')) {
                                            if (value && value !== '' && value !== null && value !== undefined) {
                                                value = moment.utc(value).format('MM/DD/YYYY')
                                            } else {
                                                value = ''
                                            }
                                        }
                                    }
                                    // Fallback for date objects
                                    else if (value && typeof value === 'object' && value.$date) {
                                        value = that.formatDateWithoutTimezone(value)
                                    }
                                    rowData[headerName] = value !== null && value !== undefined ? value : ''
                                })
                                exportData.push(rowData)
                            })
                            // Calculate column widths based on content
                            const columnWidths = {}
                            visibleColumns.forEach(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                const headerName = colDef.headerName || col.colId
                                // Start with header length
                                let maxWidth = headerName.length
                                // Check all data values for this column
                                exportData.forEach(row => {
                                    const cellValue = String(row[headerName] || '')
                                    maxWidth = Math.max(maxWidth, cellValue.length)
                                })
                                // Add padding and set max limit
                                columnWidths[headerName] = Math.min(maxWidth + 2, 50)
                            })
                            // Set up columns with calculated widths
                            worksheet.columns = visibleColumns.map(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                const headerName = colDef.headerName || col.colId
                                return {
                                    header: headerName,
                                    key: headerName,
                                    width: columnWidths[headerName]
                                }
                            })
                            // Style header row - bold and borders
                            const headerRow = worksheet.getRow(1)
                            headerRow.font = { bold: true }
                            headerRow.eachCell((cell) => {
                                cell.border = {
                                    top: { style: 'thin' },
                                    left: { style: 'thin' },
                                    bottom: { style: 'thin' },
                                    right: { style: 'thin' }
                                }
                            })
                            // Add data rows
                            exportData.forEach(rowData => {
                                worksheet.addRow(rowData)
                            })
                            // Add borders to all cells
                            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                                    cell.border = {
                                        top: { style: 'thin' },
                                        left: { style: 'thin' },
                                        bottom: { style: 'thin' },
                                        right: { style: 'thin' }
                                    }
                                })
                            })
                            // Generate file name with timestamp
                            const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss')
                            const fileName = `Recalls_Feed_${timestamp}.xlsx`
                            // Download file
                            const buffer = await workbook.xlsx.writeBuffer()
                            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                            const link = document.createElement('a')
                            link.href = URL.createObjectURL(blob)
                            link.download = fileName
                            link.click()
                            URL.revokeObjectURL(link.href)
                            that._showToast(`Exported ${data.length} visible record(s) from current page`, {
                                variant: 'success'
                            })
                        } else {
                            that._showToast('No visible records to export on current page', {
                                variant: 'warning'
                            })
                        }
                    } catch (error) {
                        console.error('Export error:', error)
                        that._showToast('Failed to export data', {
                            variant: 'danger'
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length > 2) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
        onCellValueChanged(params){
            const payload = {
                id: params.data.id,
                newRecallType: params.newValue !== '(blank)' ? params.newValue : null,
                oldRecallType: params.oldValue,
                userId: this.$store.state.user.id,
                sourcePage: 'recall-feed'
            }
            recallsFeedServices.updateOpenFDARecallType(payload).then(resp => {
                if(resp.data?.d?.success){
                    this._showToast('Recall Type updated successfully', { variant: 'success' })
                }
            })
        },
        onCellEditingStarted(params) {
            if (params.column.getColId() === 'recall_type') {
                this.activeEditingCell = {
                    rowIndex: params.rowIndex,
                    colKey: params.column.getColId(),
                    api: params.api
                }
                this.$nextTick(() => {
                    document.addEventListener('click', this.onOutsideClick)
                })
            }
        },

        onCellEditingStopped() {
            this.activeEditingCell = null
            document.removeEventListener('click', this.onOutsideClick)
        },

        onOutsideClick(event) {
            const dropdown = document.querySelector('.ag-select')

            if (dropdown && !dropdown.contains(event.target)) {
                if (this.activeEditingCell) {
                    this.activeEditingCell.api.stopEditing()
                }
            }},

        showImportModal() {
            this.deviceModalKey += 1
            this.$nextTick(() => {
                this.$refs.importDeviceModal.forceRerender()
            })
        },

        showFileStatusModal() {
            this.fileStatusModalKey += 1
            this.$nextTick(() => {
                this.$refs.fileStatusModal.forceRerender()
            })
        },
        formatDateWithoutTimezone(date) {
            if (!date) return ''
            try {
                // Parse the date string and extract components without timezone conversion
                const dateStr = date?.$date || date
                const match = String(dateStr).match(/(\d{4})-(\d{2})-(\d{2})/)
                if (match) {
                    const month = match[2]
                    const day = match[3]
                    const year = match[1]
                    return `${month}/${day}/${year}`
                }
                return date
            } catch (error) {
                return date
            }
        }
    }
}
